export default __webpack_public_path__ + "static/media/ISI-background.7ff45d4d.jpeg";